import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, ArrowRight } from 'lucide-react';
import { buildSignupUrl } from '../../lib/signupUrl';

const StickyBottomCTA = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  const [signupsThisWeek] = useState(847);
  const [spotsLeft] = useState(54);
  const signupUrl = buildSignupUrl();

  useEffect(() => {
    const handleScroll = () => {
      const scrollPercent = (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100;
      
      if (scrollPercent > 25 && !isDismissed) {
        setIsVisible(true);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isDismissed]);

  const handleDismiss = () => {
    setIsDismissed(true);
    setIsVisible(false);
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ y: 100 }}
          animate={{ y: 0 }}
          exit={{ y: 100 }}
          transition={{ type: 'spring', damping: 25, stiffness: 300 }}
          className="fixed bottom-0 left-0 right-0 z-40 glass-strong border-t border-white/10 p-4"
          data-testid="sticky-bottom-cta"
        >
          <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
            {/* Left Side */}
            <div className="flex items-center gap-4">
              {/* Avatar Stack */}
              <div className="hidden sm:flex -space-x-2">
                {[1, 2, 3].map((i) => (
                  <div 
                    key={i}
                    className="w-8 h-8 rounded-full border-2 border-surface-base bg-surface-elevated overflow-hidden"
                    style={{
                      backgroundImage: `url(https://i.pravatar.cc/80?img=${i + 20})`,
                      backgroundSize: 'cover'
                    }}
                  />
                ))}
              </div>
              <p className="text-sm text-gray-300">
                <span className="text-white font-bold">{signupsThisWeek} creators</span> signed up this week 
                <span className="text-gray-500 mx-2">·</span>
                <span className="text-brand-accent font-semibold">{spotsLeft} spots left</span> this month
              </p>
            </div>

            {/* Right Side */}
            <div className="flex items-center gap-3">
              <a
                href={signupUrl}
                className="flex items-center gap-2 bg-brand-primary hover:bg-brand-primary-hover text-surface-base px-6 py-2.5 rounded-full text-sm font-semibold transition-all duration-300 hover:-translate-y-0.5 glow-primary whitespace-nowrap"
                data-testid="sticky-cta-button"
              >
                Claim your spot
                <ArrowRight className="w-4 h-4" />
              </a>
              <button
                onClick={handleDismiss}
                className="p-2 text-gray-500 hover:text-white transition-colors"
                aria-label="Dismiss"
                data-testid="sticky-cta-dismiss"
              >
                <X className="w-5 h-5" />
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default StickyBottomCTA;
